/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goal_Fat_LossInputs */

const en_us2_onboarding_goal_fat_loss = /** @type {(inputs: Onboarding_Goal_Fat_LossInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lose fat`)
};

const pt_br2_onboarding_goal_fat_loss = /** @type {(inputs: Onboarding_Goal_Fat_LossInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder gordura`)
};

const es_419_onboarding_goal_fat_loss = /** @type {(inputs: Onboarding_Goal_Fat_LossInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder grasa`)
};

const pt_pt2_onboarding_goal_fat_loss = /** @type {(inputs: Onboarding_Goal_Fat_LossInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder gordura`)
};

const fr_fr2_onboarding_goal_fat_loss = /** @type {(inputs: Onboarding_Goal_Fat_LossInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdre du gras`)
};

const de_de2_onboarding_goal_fat_loss = /** @type {(inputs: Onboarding_Goal_Fat_LossInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fett verlieren`)
};

const it_it2_onboarding_goal_fat_loss = /** @type {(inputs: Onboarding_Goal_Fat_LossInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdere grasso`)
};

/**
* | output |
* | --- |
* | "Lose fat" |
*
* @param {Onboarding_Goal_Fat_LossInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_goal_fat_loss = /** @type {((inputs?: Onboarding_Goal_Fat_LossInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goal_Fat_LossInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_goal_fat_loss(inputs)
	if (locale === "es-419") return es_419_onboarding_goal_fat_loss(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_goal_fat_loss(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_goal_fat_loss(inputs)
	if (locale === "de-DE") return de_de2_onboarding_goal_fat_loss(inputs)
	if (locale === "it-IT") return it_it2_onboarding_goal_fat_loss(inputs)
	return en_us2_onboarding_goal_fat_loss(inputs)
});
export { onboarding_goal_fat_loss as "onboarding.goal.fat_loss" }